import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const LilyTaxonomyPage = lazy(() => import('~/features/configuration/pages/lily-taxonomy-page'));

/**
 * Lily Taxonomy — `/configuration/lily-taxonomy`. The combined product taxonomy
 * listing. Access is inherited from the parent `/configuration` route guard
 * (`requirePermission(Screens.CONFIGURATION)`); the page is platform-agnostic
 * reference data, so it ignores the inherited `?platform` param.
 *
 * Surfaces in the sidebar once the matching screen row exists in
 * `/screens/navigation` (already seeded in the MSW nav mock).
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/lily-taxonomy')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <LilyTaxonomyPage />
    </Suspense>
  ),
});
